module.exports = __webpack_public_path__ + "img/1094448991.257e6b23.jpg";